import axios from "axios";
import url from "../config/urlServiceConfig";

const orgStructureAPI = {
  getAll: () => axios.get(url.orgStructure),
  getById: (id) => axios.get(`${url.orgStructure}/${id}`),
  create: (body) => axios.post(url.orgStructure, body),
  update: (body) => axios.put(url.orgStructure, body),
  delete: (id) => axios.delete(`${url.orgStructure}/${id}`),
  getAllTree: () => axios.get(`${url.orgStructure}/ReadTree`),
};

export default orgStructureAPI;
